import { render, staticRenderFns } from "./CourseSectionViewInstructor.vue?vue&type=template&id=4c89e4c4&"
import script from "./CourseSectionViewInstructor.vue?vue&type=script&lang=js&"
export * from "./CourseSectionViewInstructor.vue?vue&type=script&lang=js&"
import style0 from "./CourseSectionViewInstructor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports